// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require('channels')
import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'

ActiveStorage.start()
Rails.start();

import $ from 'jquery'
import toastr from 'toastr'

global.$ = $
global.jQuery = $
global.toastr = toastr
global.Rails = Rails

import "controllers"

import "../view-components";
// import "../react_on_rails_components";
import "../react_components";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
      navigator.serviceWorker.register("/pwa/service-worker.js").then(reg => {
      console.log("ServiceWorker >>> registrado", reg);
      });
  });
}